module.exports = __webpack_public_path__ + "static/media/pa_systems.03fbef99.jpg";